import {
  Button,
  ButtonProps,
  Portal,
  Typography,
  alpha,
  styled,
} from '@mui/material'
import { TOUR_Z_INDEX } from '../constants'

interface Props extends ButtonProps {
  show: boolean
  title: string
}

export function SkipButton({ onClick, show, title }: Props) {
  return (
    <Portal container={window.document.body}>
      <StyledSkipButton
        onClick={onClick}
        aria-label="Skip"
        variant="outlined"
        className={show ? 'show' : ''}
      >
        <Typography color="neutral000" variant="subtitle3">
          {title}
        </Typography>
      </StyledSkipButton>
    </Portal>
  )
}

const StyledSkipButton = styled(Button)`
  height: auto;

  top: 12px;
  right: 13px;
  position: fixed;
  padding: 8px 16px;
  background-color: ${({ theme }) => alpha(theme.palette.neutral1000, 0.15)};
  z-index: ${TOUR_Z_INDEX + 101};

  border: 1px solid ${({ theme }) => alpha(theme.palette.neutral000, 0.5)};
  border-radius: ${({ theme }) => theme.shape.borderRadius * 3};

  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;

  &.show {
    opacity: 1;
    pointer-events: unset;
  }

  .MuiTouchRipple-child {
    background-color: ${({ theme }) => alpha(theme.palette.neutral1000, 0.4)};
  }

  &:hover {
    background-color: ${({ theme }) => alpha(theme.palette.neutral1000, 0.3)};
    border-color: ${({ theme }) => alpha(theme.palette.neutral000, 0.6)};
  }
`
